import authHeader from "./auth-header";
import axiosInstance from "./instance";

class DeliveryService {
  getList(params = null) {
    return axiosInstance.get("/spares_delivery", {
      headers: authHeader(),
      params,
    });
  }

  updateRow(row) {
    return axiosInstance
      .post("/spares_delivery_update_row", row, {
        headers: authHeader(),
      })
      .then((result) => result)
      .catch((error) => Promise.reject(error));
  }

  newRow(row) {
    return axiosInstance
      .post("/spares_delivery_new_row", row, {
        headers: authHeader(),
      })
      .then((result) => result)
      .catch((error) => Promise.reject(error));
  }

  getTicketsForShip(params) {
    return axiosInstance.post("/tickets", params, { headers: authHeader() });
  }
}

export default new DeliveryService();
